import  { STORE_BROKER_FIELD_DETAILS } from '../actions/storeBrokerFieldDetailsActions';;

interface BrokerFields {
    'host': string,
    'messageVpn': string,
    'clientUsername': string,
    'clientPassword': string
}

export const storeBrokerFieldDetailsReducer= (
	state: BrokerFields = {
    'host': '',
    'messageVpn': '',
    'clientUsername': '',
    'clientPassword': ''
    },
	action: {type:string, payload : {key:string, value:string}}
): any => {
	switch (action.type) {
		case STORE_BROKER_FIELD_DETAILS:
			return {
                ...state,
                [action.payload.key] :  action.payload.value
            };
		default:
			return state;
	}
}

